import PropTypes from 'prop-types'
import React from 'react'

const BillingHistoryIcon = ({
   className,
   color,
   width,
   height,
   strokeWidth
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         strokeLinecap="square"
         strokeLinejoin="miter"
         strokeWidth={strokeWidth}
         fill={color}
         stroke={color}>
         <path
            fill="none"
            stroke={color}
            strokeMiterlimit="10"
            d="M1,20v3h12v-2.583 C13,19.036,14.119,18,15.5,18H3C1.895,18,1,18.895,1,20z"
            strokeLinecap="butt"
         />
         <path
            fill="none"
            stroke={color}
            strokeMiterlimit="10"
            d="M15.5,18c1.294,0,2.5,0.924,2.5,2.5 c0,1.381,1.119,2.5,2.5,2.5h0c1.381,0,2.5-1.119,2.5-2.5V1H7v17"
            strokeLinecap="butt"
         />
         <line
            fill="none"
            strokeMiterlimit="10"
            x1="12"
            y1="7"
            x2="18"
            y2="7"
         />
         <line
            fill="none"
            strokeMiterlimit="10"
            x1="12"
            y1="12"
            x2="18"
            y2="12"
         />
      </g>
   </svg>
)

BillingHistoryIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

BillingHistoryIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1',
   width: '24px'
}

export default React.memo(BillingHistoryIcon)
